import TenantPageConstants from "./TenantConstants.js";
class TenantActions {
  // Initialize workspace groups
  initManagementGroups() {
    return {
      type: TenantPageConstants.INIT_GROUPS,
      payload: {}
    };
  }
  // Load workspaces
  loadWorkspaces() {
    return {
      type: TenantPageConstants.LOAD_WORKSPACES,
      payload: {}
    };
  }
  loadingWorkspaces() {
    return {
      type: TenantPageConstants.LOADING_WORKSPACES,
      payload: {}
    };
  }
  loadedWorkspaces(workspaces) {
    return {
      type: TenantPageConstants.LOADED_WORKSPACES,
      payload: {
        workspaces
      }
    };
  }
  // Update workspace selection
  setUserContext(userContext) {
    return {
      type: TenantPageConstants.SET_USER_CONTEXT,
      payload: userContext
    };
  }
  setPartialUserContext(userContext) {
    return {
      type: TenantPageConstants.SET_PARTIAL_USER_CONTEXT,
      payload: userContext
    };
  }
  // Load all groups for a workspace
  loadManagementGroups(workspaceId) {
    return {
      type: TenantPageConstants.LOAD_GROUPS,
      payload: {
        workspaceId
      }
    };
  }
  loadingManagementGroups() {
    return {
      type: TenantPageConstants.LOADING_GROUPS,
      payload: {}
    };
  }
  loadedManagementGroups(workspace, groups, error) {
    return {
      type: TenantPageConstants.LOADED_GROUPS,
      payload: {
        workspace,
        groups,
        error
      }
    };
  }
  // Load current workspace/group for this user
  loadCurrentManagementGroup() {
    return {
      type: TenantPageConstants.LOAD_CURRENT_GROUP,
      payload: {}
    };
  }
  loadingCurrentManagementGroup() {
    return {
      type: TenantPageConstants.LOADING_CURRENT_GROUP,
      payload: {}
    };
  }
  loadedCurrentManagementGroup(workspaceId, path) {
    return {
      type: TenantPageConstants.LOADED_CURRENT_GROUP,
      payload: {
        currentWorkspace: workspaceId,
        currentGroup: path
      }
    };
  }
  // Set new workspace/group for this user
  updateCurrentManagementGroup(workspaceId, path, onComplete) {
    return {
      type: TenantPageConstants.UPDATE_CURRENT_GROUP,
      payload: {
        workspaceId,
        newGroup: path,
        onComplete
      }
    };
  }
  updatingCurrentManagementGroup() {
    return {
      type: TenantPageConstants.UPDATING_CURRENT_GROUP,
      payload: {}
    };
  }
  updatedCurrentManagementGroup() {
    return {
      type: TenantPageConstants.UPDATED_CURRENT_GROUP,
      payload: {}
    };
  }
}
const TenantActions$1 = new TenantActions();
export {
  TenantActions,
  TenantActions$1 as default
};
//# sourceMappingURL=TenantActions.js.map
